import { notifiableValue } from '../notifiableValue';

/**
 * Tracks whether the operator's Midway session has expired, so the UI can offer a login.
 *
 * A module-level flag because neither path that discovers the failure -- init, and signing -- can report it
 * to the readers that need it: piezoLink and the navbar.
 */

/** Used by both the sign worker and the UI, so they classify an auth failure identically. */
const AUTH_ERROR_PATTERN = /NO_MIDWAY_SESSION|AUTHENTICATION_FAILED|\b401\b|Unauthorized|midway/i;

export function isMidwayAuthError(err: unknown): boolean {
  return AUTH_ERROR_PATTERN.test(err instanceof Error ? err.message : String(err ?? ''));
}

/** The button's label, and the name MIDWAY_EXPIRED_MESSAGE calls it by. */
export const MIDWAY_LOGIN_LABEL = 'Log in again';

export const MIDWAY_EXPIRED_MESSAGE =
  'Your Midway session has expired, so tool calls can no longer be signed. Click the ' +
  `"${MIDWAY_LOGIN_LABEL}" button at the top of the page. Reloading will not help: the session is renewed ` +
  'by signing in again, not by loading the page.';

const expired = notifiableValue(false);

export function recordMidwaySessionExpired(): void {
  expired.set(true);
}

export function clearMidwaySessionExpired(): void {
  expired.set(false);
}

export function isMidwaySessionExpired(): boolean {
  return expired.get();
}

export const onMidwaySessionChange = expired.onChange;
